export default __webpack_public_path__ + "0c1fc1d01abec7091fea9faadbecdd65.jpg";